// A background being dragged into shape (a veil's or a gradient's slider): drawn on the slide open in the editor as it
// moves, and written once, when it is let go (S6). Nothing is written while it moves.

import { create } from "zustand";
import type { SlideBg } from "../../../../shared/slideDesign";

export const useBgDraft = create<{ on: boolean; bg: SlideBg | null }>(() => ({ on: false, bg: null }));

export const draftBg = (bg: SlideBg | null) => useBgDraft.setState({ on: true, bg });
export const endDraft = () => useBgDraft.setState({ on: false, bg: null });
